// base
import React, { useEffect, useState } from 'react';

// styles
import { StyledSignInBackground } from './style';

// constants
import { commonImage, loginImage, loginImages } from 'constants/images';

// libraries
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

export const SignInBackground: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [swiperInstance, setSwiperInstance] = useState<SwiperCore | undefined>(undefined);

  const onChangePlay = () => {
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    if (!swiperInstance) return;

    if (isPlaying) {
      swiperInstance.autoplay.start();
    } else {
      swiperInstance.autoplay.stop();
    }
  }, [isPlaying, swiperInstance]);

  return (
    <StyledSignInBackground>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          renderBullet: (_, className) => {
            return '<span class="' + className + '"></span>';
          }
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false
        }}
        loop
        effect="fade"
        modules={[Navigation, Pagination, A11y, Autoplay, EffectFade]}
        onSwiper={setSwiperInstance}
      >
        <div className="sib-header">
          <div className="sib-header-play" onClick={onChangePlay}>
            <img src={isPlaying ? commonImage.carouselStop : commonImage.carouselPlay} />
          </div>
          <div className="sib-header-pagination swiper-pagination" />
        </div>

        {loginImages.map((item, idx) => (
          <SwiperSlide key={idx}>
            <img src={item.src} alt={`sign-in-background-${idx + 1}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledSignInBackground>
  );
};
